<!--
    Object component of cw.CwRequest — branches on uiMode exactly like cw-case-object.component.html.

    'inline'  → the compact card (loads on its own; see its class doc).
    otherwise → the context header, fed with the DTO this shell already loaded.

    The capture surface stays with CwRequestCapturePage: the entity-provider registers
    objectComponent only, never objectPageComponent, so cw/request/:id keeps resolving to that page.
-->
@if (uiMode == 'inline') {
    <cw-request-inline-component
            [objectIdentifier]="objectIdentifier"
            [importObjectContext]="importObjectContext"
    ></cw-request-inline-component>
} @else if (initialized && dto) {
    <mvs-cw-request-context-header
            class="block"
            [request]="request"
            (onCancelled)="onRequestCancelled()">
    </mvs-cw-request-context-header>
}
